import { Container } from '@/components';
import { DateRangeDropdown } from '@/components/DateRangeDropdown';
import { ReactElement, useState } from 'react';
import { DateRange } from 'react-day-picker';
import { useTranslation } from 'react-i18next';
import { TaskLabourTimeAutomatedCard } from './TaskAreaLabourTimeAutomatedCard';
import { TaskTotalReturnCard } from './TaskTotalReturnCard';

type TaskPerformanceCardsProps = {
  taskId: number;
};

export const TaskPerformanceCards = ({
  taskId,
}: TaskPerformanceCardsProps): ReactElement => {
  const { t } = useTranslation();
  const [dateRange, setDateRange] = useState<DateRange>();

  return (
    <div className="flex flex-wrap gap-2">
      <Container
        title={t('auto_and_invest_performance')}
        className="flex-1"
        actions={
          <DateRangeDropdown
            range={dateRange}
            onChange={setDateRange}
            placement="bottom-end"
          />
        }
      >
        <div className="flex gap-3">
          <TaskLabourTimeAutomatedCard
            taskId={taskId}
            automationPerformanceDateRange={dateRange}
          />
          <TaskTotalReturnCard
            taskId={taskId}
            automationPerformanceDateRange={dateRange}
          />
        </div>
      </Container>
    </div>
  );
};
